module.exports = __webpack_public_path__ + "img/sg4.f1fa5b54.png";